export default __webpack_public_path__ + "static/media/link-clicked.002ea3b2.svg";